import { Button, PageLayout } from '@pms-digital/design-system';

interface EcranProfilProps {
  /** Called by "se déconnecter". No confirmation is asked. */
  onLogout: () => void;
}

/**
 * The profile page, the only one the profile entry of the shell (PMS design system) can lead
 * to: the charter puts the logout in it, not in the icon rail. Rosetta has nothing else to show
 * about the user yet, so it holds the logout and nothing more.
 */
export function EcranProfil({ onLogout }: EcranProfilProps) {
  return (
    <PageLayout width="narrow" title="Profil">
      <Button variant="primary" icon="logout" onClick={onLogout}>
        se déconnecter
      </Button>
    </PageLayout>
  );
}
